// extracted by mini-css-extract-plugin
module.exports = {"amountButton":"DonationPriceForm_amountButton__2iOt_"};